module.exports = __webpack_public_path__ + "img/rr.8487d87d.png";